import { Component, OnInit } from '@angular/core';
import { AHRService, Supervisor, DossierService } from '../../../domain';
import { DossierExportDataModalComponent } from '../../../widgets/dossier-export-data/dossier-export-data-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { SUPERVISOR_REVIEW_LOOKBACK_YEARS } from 'app/shared/constants';

@Component({
    selector: 'my-supervisors',
    templateUrl: './my-supervisors.component.html',
    styleUrls: ['./my-supervisors.component.scss']
})
export class MySupervisorsComponent implements OnInit {
	allPeriodType = true;
    supervisorList: Supervisor[] = [];
    loading = true;
    infoPanelOpenState = false;
    
    constructor(
        private ahrService: AHRService,
        private matDialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.ahrService.getSupervisorsForCurrentUser().subscribe(
            supervisors => {
                this.supervisorList = supervisors;
                this.loading = false;
            },
            error => {
                console.log("error getting supervisors list: " + error.message);
                this.loading = false;
            }
        );
    }

    getFormattedRole(id: string): string{
        let participationOptions = [{ id: 'WritesReview', label: 'Write Review' }, { id: 'ReadOnly', label: 'Read-only' }];
        return participationOptions.find(p => p.id === id)?.label || id;
    }

    getSupervisorTitle(originalIndex: number): string {
        if (originalIndex === 0) return 'Primary';
        if (originalIndex === 1) return 'Secondary';
        return 'Additional';
    }

    //Open export data modal
    openExportDataDialog(){
        let minDate = new Date();
        let maxDate = new Date();
        minDate.setFullYear(minDate.getFullYear() - SUPERVISOR_REVIEW_LOOKBACK_YEARS); 
        maxDate.setFullYear(maxDate.getFullYear() + 1);
        this.matDialog.open(DossierExportDataModalComponent, {
            width:'500px',
            disableClose: true,
            data: { minDate: minDate,
                    maxDate: maxDate},
            hasBackdrop: true
        });
    }  
}